//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Swipe, SwipeItem } from 'vue-swipe'
import Util from '@/common/js/util'

export default {
  // name: 'xxxxxxxx',
  props: ['datas', 'parentData', 'swipeIdx', 'yearIdx'],
  components: {
    swipe: Swipe,
    'swipe-item': SwipeItem,
  },
  data() {
    return {
      // newIncomeArr: [],
    }
  },
  created() {
    // this.newIncomeArr = this.datas
    // console.log('this.datas', this.newIncomeArr)
    // console.log('parentData', this.parentData)
  },
  mounted() {},
  methods: {
    returnType(type) {
      const arr = Util.getTypeArrFn()
      return arr[type - 1]
    },
    getRiskFn(Rating) {
      return Util.getRiskFn(Rating)
    },
    changSwipeFn(idx, old) {
      // console.log('this.$refs.swipe子', this.$refs.swipe)
      this.$emit('changeSwipe', {
        idx,
        old,
        data: {
          yearIdx: this.yearIdx,
          swipeIdx: this.swipeIdx,
          // datas: this.datas,
          // parentData: this.parentData,
        },
      })

      // console.log('切换翻页', idx, old)
    },
    investBtnFn(type, url) {
      if (type == 1) {
        this.$emit('showDialogQR', url)
        // this.qrImg = url
        // this.showDialogQrFn()
      } else {
        window.location.href = url
      }
    },
  },
  computed: {},
  // watch: {
  //   datas() {
  //     this.newIncomeArr = this.datas

  //     console.log('this.datas', this.newIncomeArr)
  //   },
  // },
}



// WEBPACK FOOTER //
// ./src/pages/components/swiper.vue